export const queryKeys = {
  user: "user",
  users: "users",
  category: "category",
  service: "service",
  team: "team",
  product: "product",
  productFeature: "productFeature",
  testimony: "testimony",
  carousel: "carousel",
  Request: "Request",
  fastTrack: "fastTrack",
  metrics: "metrics",
};
